import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaCheck from 'react-icons/lib/fa/check';

import localize from 'wanderu-i18n/src/localize';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ValueProp.scss';

const VALUE_PROP_KEYS = [
    'lowestPrices',
    'bestTravelOptions',
    'quickEasyBooking',
    'fastCustomerSupport',
];

function ResponsiveValueProps(props) {
    const {
        className = '',
        compact = false,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isLargeScreen: _isLargeScreen,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isMediumScreen: _isMediumScreen,
        isSmallScreen,
        t,
    } = props;

    const isCompact = compact || isSmallScreen;
    const containerClassName = classNames(
        className,
        styles.valuePropContainer,
        { [styles.compact]: isCompact },
    );
    const headerClassName = classNames(
        styles.header,
        { [styles.compact]: isCompact },
    );
    const itemClassName = classNames(
        styles.valueProp,
        { [styles.compact]: isCompact },
    );
    const showDescriptions = !isCompact;

    return (
        <div className={containerClassName}>
            {VALUE_PROP_KEYS.map((key) => (
                <div
                    className={itemClassName}
                    key={key}
                >
                    <div className={headerClassName}>
                        <FaCheck className={styles.checkmark} />
                        <span className={styles.valuePropText}>
                            {t(key)}
                        </span>
                    </div>

                    {showDescriptions && (
                        <div className={styles.description}>
                            {t(`${key}Explanation`)}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

ResponsiveValueProps.propTypes = {
    className: PropTypes.string,
    compact: PropTypes.bool,
    isLargeScreen: PropTypes.bool,
    isMediumScreen: PropTypes.bool,
    isSmallScreen: PropTypes.bool,
    t: PropTypes.func,
};

const LocalizedValueProps = localize(ResponsiveValueProps, ['t'], 'baseApp');

function ValueProps(props) {
    const {
        withDescriptions = false,
        ...otherProps
    } = props;

    if (withDescriptions) {
        return (
            <LocalizedValueProps
                {...otherProps}
            />
        );
    }

    return (
        <LocalizedValueProps
            compact
            {...otherProps}
        />
    );
}

ValueProps.propTypes = {
    className: PropTypes.string,
    compact: PropTypes.bool,
    element: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.instanceOf(typeof Element !== 'undefined'
            ? Element
            : Object),
    ]),
    withDescriptions: PropTypes.bool,
};

export {
    ResponsiveValueProps,
    ValueProps,
};

export default ValueProps;
